var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();

// game variables
type circle = [number, number, number];
var playerX: number;
const playerY = 90;
var playerSpeed: number;
const acceleration = 30;
var circles: circle[];
var fallingSpeed: number;
const fallingAcceleration = 0.2;
const spawnProb = 0.6;
var ended: boolean;

function initialize() {
    playerX = 50;
    playerSpeed = 0;
    circles = [];
    fallingSpeed = 5;
    ended = false;
}

function draw() {
    context.resetTransform();
    context.clearRect(0, 0, width, height);
    context.translate(0, height-width);
    context.scale(width/100, width/100);
    
    // draw triangle
    context.fillStyle = "red"
    context.beginPath();
    context.moveTo(playerX, playerY);
    context.lineTo(playerX + 3, playerY + 8);
    context.lineTo(playerX - 3, playerY + 8);
    context.fill();
    // draw circles
    context.fillStyle = "blue";
    for(let c of circles) {
        if(c[1] < 120) {
            context.beginPath();
            context.moveTo(c[0] + c[2], c[1]);
            context.arc(c[0], c[1], c[2], 0, 2*Math.PI);
            context.fill();
        }
    }
    context.font = "4px sans-serif";
    context.fillStyle = "black";
    context.fillText("Score: " + Math.round(fallingSpeed).toString(), 3, 80);
    context.fillText("press R to restart", 65,80)
    context.fillStyle = "rgb(70%, 0%, 0%)"
    if(ended) {
        context.fillText("You died!", 40,80)
    }

}

function update(dt: number) {
    if(ended) {
        return;
    }
    // update player speed
    if (keyStates.has("ArrowLeft")) {
        playerSpeed -= acceleration*dt;
    }
    if (keyStates.has("ArrowRight")) {
        playerSpeed += acceleration*dt;
    }
    // update player position
    playerX += playerSpeed*dt;
    if(playerX < 5) {
        playerX = 5;
        playerSpeed = 0;
    }
    if(playerX > 95) {
        playerX = 95;
        playerSpeed = 0;
    }
    // update falling speed
    fallingSpeed += fallingAcceleration*dt;
    // update circle positions and check for collisions
    for(let c of circles) {
        c[1] += fallingSpeed*dt;
        if(checkCollision(c)) {
            ended = true;
            break;
        }
    }
    // spawn new circles
    if(Math.random() < spawnProb*dt) {
        circles.push([Math.random()*100, 30, 7*(Math.random()+0.4)])
    }
    // TODO despawn
}

function checkCollision(c: circle) {
    let dx = c[0]-playerX;
    let dy = c[1]-playerY;
    if(dx*dx + dy*dy < c[2]*c[2]) {
        return true;
    }
    dx = c[0]-(playerX+3);
    dy = c[1]-(playerY+8);
    if(dx*dx + dy*dy < c[2]*c[2]) {
        return true;
    }
    dx = c[0]-(playerX-3)
    if(dx*dx + dy*dy < c[2]*c[2]) {
        return true;
    }
    return false;
}

function loop(t_ms: number) {
    // calculate dt
    let dt = t_ms - last_tick_t;
    last_tick_t = t_ms;

    update(dt / 1000); // to seconds
    draw();

    window.requestAnimationFrame(loop);
}

function resized() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
}

function key(e: KeyboardEvent) {
    switch (e.type) {
        case "keydown":
            keyStates.add(e.key);
            if(e.key == "r") {
                initialize();
                draw();
            }
            break;
        case "keyup":
            keyStates.delete(e.key);
            break;
        default:
            console.warn("Wut?");
    }
}

function main() {
    initialize();
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    window.addEventListener("resize", resized);
    resized();

    loop(performance.now());
}


main();